export module Evaluation {
    export function evaluateToStyleWidthHeight(value: any): string {
        if (typeof value === "function") {
            return this.evaluateToStyleWidthHeight(value()); // It is a function
        } else if (typeof value === "number" || +value) {
            return value + 'px'; // We know its a number
        } else {
            return value; // We know its a string;
        }
    }
}



// WEBPACK FOOTER //
// ./client-src/app/core/utils/evalutaion.ts